
import { Component, Vue } from 'vue-property-decorator';
import config from '@/config';

// Resolves the home component for the current platform at runtime.
// Tries homes/<platformUuid>.vue; falls back to homes/default.vue if
// the UUID is absent or no matching file exists.
function resolveHome() {
  const slug = config.platformUuid || 'default';
  return () =>
    import(/* webpackChunkName: "home-[request]" */ `../../homes/${slug}.vue`).catch(
      () => import('../../homes/default.vue'),
    );
}

@Component
export default class Home extends Vue {
  readonly activeHome = resolveHome();
}
